import { TableActionsOptions } from './../types';
import { Table } from '@tanstack/react-table';
import get from 'lodash/get';

const getTableActionOptions = <T>(table: Table<T>): TableActionsOptions =>
  get(table, 'options.meta.actionOptions', null);

export default getTableActionOptions;
